<template>
  <div class="col-12 backgroundForm">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Reportes Ingresos</h4>
            <p>Reportes de Ingresos percibidos por conceptos varios</p>        
        </div>

        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="exec-reg" data-toggle="tab" href="#rep-list-doc" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="tasks" /> Detalle Ingresos</a>

                <a class="nav-item nav-link" id="exec-approv-gral" data-toggle="tab" href="#rep-res-doc" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="tasks" /> Ingresos Resumen </a>

                <a class="nav-item nav-link" id="exec-gral" data-toggle="tab" href="#rep-cap-ing" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="folder-open" /> Ingreso por Capitanias</a>

                <!-- <a class="nav-item nav-link" id="exec-gral" data-toggle="tab" href="#rep-ing-gral" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="folder-open" /> Grafico Ingresos</a> -->

            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Registro de la solicitud de ejecucion presupuestaria -->
            <div class="tab-pane fade show active" id="rep-list-doc" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                 <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Detalle de Ingresos declarados o descargados por sistema
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                        <label for="type_operation">Operacion</label>
                        <select name="type_operation" id="type_operation" class="form-control" v-model="operation_doc_select" @change="mClearResult">
                            <option v-for="op in types_operation" :key="op.id" :value="op">{{ op.description }}</option>
                        </select>

                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="type_operation">Reparticion</label>
                        <select name="type_operation" id="type_operation" class="form-control" v-model="captain_doc_select" @change="mClearResult">
                            <option v-for="cap in captains" :key="cap.id" :value="cap">{{ cap.name_port }}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="time_init_ordop">Fecha Inicio </label>
                            <datetime ref="doc_init" v-model="doc_individually.init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Fecha" title="Hora de Inicio" value-zone="America/La_Paz" @change="mClearResult"></datetime>
                            <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                    </div>

                    <div class="form-group col-12 col-md-4">
                            <label for="time_init_ordop">Fecha Final </label>
                            <datetime v-model="doc_individually.end" id="date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Fecha" title="Hora de Inicio" value-zone="America/La_Paz" @change="mClearResult"></datetime>
                            <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-2 offset-md-5" @click="mSearchDocuments">Buscar <font-awesome-icon icon="search" /></button>
                <br><br>
                
                <div class="table-responsive" :id="id_copy_table" v-if="discharge.length > 0">
                    <button class="btn btn-warning col-5 col-md-1 offset-md-10" @click="mCopyToClipboard(id_copy_table)"><font-awesome-icon icon="copy" size="2x"/></button>
                    <br><br>
                    <div id="printDetail">
                    <table class="table table-sm">
                        <thead>
                            <tr class="thead-dark"><th :colspan="totales_doc.snh > 0 ? 9:7" style="text-align:center">{{ captain_doc_select.name_port }}</th></tr>
                            <tr class="thead-dark"><th :colspan="totales_doc.snh > 0 ? 9:7" style="text-align:center" >{{ operation_doc_select.description }}</th></tr>
                            <tr class="thead-dark"><th :colspan="totales_doc.snh > 0 ? 9:7" style="text-align:center">{{ this.doc_individually.init }} al {{ this.doc_individually.end }}</th></tr>
                            <tr class="thead-dark">
                                <th>#</th>
                                <th>Fecha Descargo</th>
                                <th>Documento Descargo</th>
                                <th>Depositos o Transferencias</th>
                                <th>Operacion</th>
                                <th>No. Documento</th>
                                <th>Importe</th>
                                <th v-if="totales_doc.snh > 0">Importe SNH</th>
                                <th v-if="totales_doc.snh > 0">Total</th>
                            </tr>
                        </thead>
                        <tbody v-html="table_master">
                            
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade show" id="rep-res-doc" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Resumen de Ingresos por Capitania
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="type_operation">Reparticion</label>
                        <select name="type_operation" id="type_operation" class="form-control" v-model="captain_resumen_only" @change="mClearResultResume">
                            <option :value="{id:0}">TODAS LAS CAPITANIAS</option>
                            <option v-for="cap in captains" :key="cap.id" :value="cap">{{ cap.name_port }}</option>
                        </select>
                    </div>
                </div>
                 <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-2">
                            <label for="time_init_ordop">Fecha Inicio </label>
                            <datetime ref="doc_init" v-model="resume_captain.init" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Fecha" title="Hora de Inicio" value-zone="America/La_Paz" @change="mClearResult"></datetime>
                            <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                    </div>

                    <div class="form-group col-12 col-md-4">
                            <label for="time_init_ordop">Fecha Final </label>
                            <datetime v-model="resume_captain.end" id="date_end" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Seleccione Fecha" title="Hora de Inicio" value-zone="America/La_Paz" @change="mClearResult"></datetime>
                            <!-- <input type="number" v-model="dts_ordop.time_init" class="form-control" name="time_init_ordop" > -->
                    </div>
                </div>
                <button class="btn btn-success col-12 col-md-2 offset-md-5" @click="mGetResumeCaptain">Listar <font-awesome-icon icon="list" /></button>
                <br><br>
                <div class="table-responsive" v-if="table_resume !== null">
                    <table class="table table-hover">
                        <thead>
                            <tr class="thead-dark"><th colspan="3" style="text-align:center" >{{ captain_resumen_only.id >0 ? captain_resumen_only.name_port: 'TODAS LAS CC.PP.'}}</th></tr>
                            <tr class="thead-dark"><th colspan="3"  style="text-align:center">{{dates_select.init}} al {{dates_select.end}}</th></tr>
                            <tr class="thead-dark">
                                <th>#</th>
                                <th>DETALLE</th>
                                <th>Imp. Bs.</th>
                            </tr>
                        </thead>
                        <tbody v-html="table_resume">

                        </tbody>
                    </table>
                </div>

            </div>

            <div class="tab-pane fade show" id="rep-cap-ing" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="form-group col-12 col-md-4 offset-md-4">
                        <label for="t_file">Gestión</label>
                        <select id="t_document" class="form-control" v-model="year_import_select" @change="mClearResume">
                            <option v-for="yv in year_option_imports" :key="yv.id" :value="yv.id">{{ yv.anio }}</option>
                        </select>
                    </div>
                </div>

                <button class="btn btn-success col-12 col-md-2 offset-md-5" @click="mSearchMonthEnter">Buscar <font-awesome-icon icon="list" /></button>
                <br>
                    <div class="alert alert-warning">Los resultados obtenidos corresponden a todos los ingresos registrados por sistema, los descargados y no descargados</div> 
                    <div class="col-12 col-md-4 offset-md-8 d-print-none" v-if="dts_ports_year.length > 0">
                        <button class="btn btn-outline-primary" @click="mCopyToClipboard('printTable')">
                            <font-awesome-icon icon="copy" /><br>copiar 
                        </button>
                    </div>
                    <br>
                    
                    <div class="table-responsive" v-if="dts_ports_year.length > 0" id="printTable">
                        <table class="table table-hover">
                            <thead>
                                <tr class="thead-dark">
                                    <th colspan="17" style="text-align:center">Resumen Ingresos gestion {{year_import_select}} <br> Capitanias de Puerto</th>
                                </tr>
                                <tr class="thead-dark">
                                    <th style="text-align:center">#</th>
                                    <th style="text-align:center">CC.PP.</th>
                                    <th style="text-align:center">ENERO</th>
                                    <th style="text-align:center">FEBRERO</th>
                                    <th style="text-align:center">MARZO</th>
                                    <th style="text-align:center">ABRIL</th>
                                    <th style="text-align:center">MAYO</th>
                                    <th style="text-align:center">JUNIO</th>
                                    <th style="text-align:center">JULIO</th>
                                    <th style="text-align:center">AGOSTO</th>
                                    <th style="text-align:center">SEPTIEMBRE</th>
                                    <th style="text-align:center">OCTUBRE</th>
                                    <th style="text-align:center">NOVIEMBRE</th>
                                    <th style="text-align:center">DICIEMBRE</th>
                                    <th style="text-align:center">AYUDA<br>NAVEGACION</th>
                                    <th style="text-align:center">INGRESOS</th>
                                    <th style="text-align:center">TOTAL</th>
                                </tr>
                            </thead>
                            <tbody v-html="results_enters" class="text-table">
                                
                            </tbody>
                        </table>
                    </div>
                </div>
            
            <!-- <div class="tab-pane fade show" id="rep-ing-gral" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <h1>en construccion</h1>
            </div> -->

        </div>
  </div>

</template>

<script>

import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

import modalLoading from '../modal/modalLoading';

export default {
    name:'report-enter',
    mounted(){
        this.mCallOptions();
        this.mObtainYear();
    },
    data(){
        return{
            year_option_imports:[],
            year_import_select:0,
            table_master:'',
            documents:[],
            discharge:[],
            master:[],
            totales_doc:{total:0, snh:0},
            types_operation:[],
            captains:[],
            captain_doc_select:{},
            operation_doc_select:{},
            doc_individually:{
                init:null,
                end:null,
            },
            resume_captain:{
                init:null,
                end:null
            },
            id_copy_table:'id_table_result',
            captain_resumen_only:{id:0},
            listEnterCaptain:[],
            dates_select:{
                init:null,
                end:null
            },
            table_resume:null,
            dts_import_year:[],
            dts_ports_year:[],
            results_enters:null
        }
    },
    methods:{
        mClearResume(){
            this.dts_import_year=[];
            this.dts_ports_year=[];
            this.results_enters=null;
        },
        mObtainYear(){
            this.year_option_imports=[];
            let anio=new Date();
            let current_year=anio.getFullYear();
            let old_year=anio.getFullYear()-10;
            for(let i = old_year ; i<=current_year ;i++){
                let auxYear={
                    id:i,
                    anio:i
                }
                this.year_option_imports.push(auxYear);
            }
        },
        async mSearchMonthEnter(){
            if(this.year_import_select > 0){
                // enviamos al servidor para solicitar el resumen de ingresos
                let dtsResume=await axios.get(`getEnterMonths/${this.year_import_select}?api_token=${Vue.auth.getToken()}`);
                // console.log(dtsResume);
                this.dts_import_year=dtsResume.data.import_months;
                this.dts_ports_year=dtsResume.data.ports;
                this.mGenerateTableImports();
            }else{
                toastr.warning(`Seleccione la Gestion que desea buscar resultados`, 'Advertencia');
            }
            
        },
        mGenerateTableImports(){
            // console.log(this.dts_import_year);
            this.results_enters='';
            let total_an=0;
            let total_ing=0;
            this.dts_ports_year.forEach((dp, key)=>{
                this.results_enters+=`<tr>
                    <td>${ key+1 }</td>
                    <td>${ dp.category } ${ dp.name_port }</td>`;
                
                let aux_an=0;
                let aux_ing=0;
                let sumMes=0;
                // aqui recorremos los meses de ingresos
                for(let i = 1; i <= 12; i++){
                   
                        let index_import = this.dts_import_year.findIndex( ib => (parseInt(ib.code_port) === parseInt(dp.code_port) && parseInt(ib.month) === i) );
                        
                        sumMes=parseFloat(this.dts_import_year[index_import].aux_penalty)+parseFloat(this.dts_import_year[index_import].dispatch)+parseFloat(this.dts_import_year[index_import].enrollment_renew);
                        
                        let result= sumMes > 0 ? sumMes - parseFloat(this.dts_import_year[index_import].snh):0; 
                        
                        aux_an+=parseFloat(this.dts_import_year[index_import].snh);
                        aux_ing+=sumMes-parseFloat(this.dts_import_year[index_import].snh);
                        this.results_enters+=`<td>
                            ${ result }<br>
                            ${ this.dts_import_year[index_import].snh }
                        </td>`;
                        sumMes=0;
                    
                }
                total_an+=aux_an;
                total_ing+=aux_ing;
                this.results_enters+=`<td>${ aux_an.toFixed(2) }</td>`;
                this.results_enters+=`<td>${ aux_ing.toFixed(2) }</td>`;
                this.results_enters+=`<td>${ parseFloat(aux_ing) + parseFloat(aux_an) }</td>`;
                this.results_enters+=`</tr>`;

            });
            this.results_enters+=`<tr><td colspan="14">TOTAL</td><td>${ total_an.toFixed(2) }</td><td>${ total_ing.toFixed(2) }</td><td>${ parseFloat(total_ing)+parseFloat(total_an) }</td></tr>`;
                
        },
        mCopyToClipboard(elemento) {

            var $temp = $("<input>")
            $("body").append($temp);
            // console.log($(`#${elemento}`));
            $temp.val($(`#${elemento}`).html()).select();
            document.execCommand("copy");
            $temp.remove();
            toastr.info('Tabla copiada con exito', 'Archivo copiado')
        },
        mClearResult(){
            this.documents=[];
            this.master=[];
            this.discharge=[];
            this.table_master='';
        },
        mClearResultResume(){
            this.listEnterCaptain=[];
            this.table_resume=null;
        },
        mPrintWindow(){
            this.$htmlToPaper('printDetail');
        },
        async mCallOptions(){
            let operations=await axios.get(`dtsOperations?api_token=${Vue.auth.getToken()}`);
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`)
            
            // console.log(operations);
            this.captains=cp.data;
            this.types_operation=operations.data;
        },
        async mGetResumeCaptain(){
            // recuperamos los datos de las cc.pp. sus ingresos
            console.log(this.captain_resumen_only.id);
            this.table_resume=null;
            if( this.resume_captain.init !== null && this.resume_captain.end !== ''){
                if(this.captain_resumen_only.id>=0){
                    let init_aux=this.resume_captain.init.split('T');
                    let end_aux=this.resume_captain.end.split('T');
                    // console.log('enviando al servidor');
                    this.dates_select.init=init_aux[0];
                    this.dates_select.end=end_aux[0];
                    let results=await axios.get(`dtsResumeEnterCaptain/${this.captain_resumen_only.id}/${init_aux[0]}/${end_aux[0]}?api_token=${Vue.auth.getToken()}`);
                    
                    
                    let resume=results.data;
                    let sum_total=0;
                    let t_aux='';
                    this.types_operation.forEach( (rs, index) => {
                        t_aux+=`<tr>`;
                        let idop=resume.findIndex( to => to.concept === rs.id);
                        if(idop > -1){
                            t_aux+=`<td>${index+1}</td> <td>${rs.description}</td> <td>${resume[idop].sum_importe}</td>`
                            sum_total+=parseFloat(resume[idop].sum_importe);
                        }else{
                            t_aux+=`<td>${index+1}</td> <td>${rs.description}</td> <td>0</td>`
                        }
                        t_aux+=`</tr>`;
                    })
                    t_aux+=`<tr><td colspan="2">TOTAL </td><td>${sum_total}</td>`;
                    this.table_resume=t_aux;
                }else{
                    toastr.warning('Seleccione todas las opciones disponibles en el formulario');
                }
            }else{
                toastr.warning('Seleccione ambas fechas');
            }
        },
        async mSearchDocuments(){
            // console.log(`enviando al servidor datos`);
            this.documents=[];
            this.totales_doc.total=0;
            this.totales_doc.snh=0;

            if(this.mValidateForm()){
                // console.log('enviando al servidor la busqueda');
                let rd=await axios.get(`searchDocuments/${this.doc_individually.init}/${this.doc_individually.end}/${this.operation_doc_select.id}/${this.captain_doc_select.id}?api_token=${Vue.auth.getToken()}`);
                // console.log(rd);
                let dt=rd.data;
                    this.totales_doc.total=0;
                    this.totales_doc.snh=0;
                    this.documents=[];
                    this.master=[];
                    this.discharge=[];
                if(dt.length > 0){
                    // console.log(dt);
                    dt.forEach(d=>{
                        let detail_aux=d.detail;
                        // foreach del detail
                        let doc;
                        detail_aux.forEach( det=>{
                            this.totales_doc.total += parseFloat(det.total);
                            this.totales_doc.snh += det.snh ? parseFloat(det.snh) : 0;
                            let op_aux=det.operation;
                            let t_op=null;
                            switch (op_aux){
                                case 'M':
                                    t_op='MATRICULACION';
                                break;

                                case 'R':
                                    t_op='RENOVACION';
                                break;

                                default:
                                    t_op=op_aux;
                                break;

                            }
                            doc={
                                master:det.master,
                                id_document:det.id_document,
                                correlative:det.correlative,
                                operation:t_op ,
                                anio:det.anio,
                                snh:det.snh ? det.snh : 0,
                                total:det.total,
                                t_dispatch:det.t_dispatch
                            }
                        console.log(doc)
                        this.documents.push(doc);
                        })//end detail
                        console.log(this.documents.length);
                        let detail_count=d.detail;
                        d.discharge.forEach(ds =>{
                            this.discharge.push(ds);
                        })
                        
                        let master_temp={
                            date_download:d.master.date_download,
                            document_master:d.master.document_master,
                            document_year:d.master.document_year,
                            master:d.master.id_t_master,
                            import_gral:parseFloat(d.master.import_gral),
                            rows:detail_count.length
                        };
                        this.master.push(master_temp);                
                    });
                    this.mArmtable();
                }else{
                    toastr.info('No se encontraron resultados', 'Sin resultados')
                }
            }
        },
        mArmtable(){
            this.table_master='';
            this.totales_doc.snh;
            let complete='';
            let init='';
            
            // console.log(this.discharge);
            this.master.forEach((mast, key) => {
                let docs='';
                init='';
                let des='';
                init=`<tr>
                        <td class="align-middle" style="text-align:center" rowspan=${mast.rows}>${key+1}</td>
                        <td class="align-middle" style="text-align:center" rowspan=${mast.rows}>${ mast.date_download }</td>
                        <td class="align-middle" style="text-align:center" rowspan=${mast.rows}>${ mast.document_master }/${ mast.document_year } </td>`;
                init+=`<td class="align-middle" rowspan=${mast.rows}>`;
                this.discharge.forEach(dis=>{
                    if(dis.master === mast.master){
                        init+=`${dis.document_description} No. ${dis.number_doc_download} / ${dis.date_document}<br>`;
                    }                    
                });
                init+=`</td>`;
                // init+=des;
                this.documents.forEach( doc =>{
                    if(doc.master === mast.master){
                        let letter;
                        // console.log(doc.t_dispatch);
                        if(doc.t_dispatch !== undefined){
                            letter=doc.t_dispatch === 'N' ? '': '(SANCION)';
                        }else{
                            letter='';
                        }
                        
                        docs+=`<td>${ doc.operation } ${ letter }</td>
                                    <td>${ doc.id_document }/${ doc.anio } </td>`;
                            if(this.totales_doc.snh > 0){
                                docs+=`
                                    <td>${ doc.total - doc.snh }</td>
                                    <td>${ doc.snh }</td>
                                    <td>${ parseFloat(doc.total).toFixed(2) }</td></tr>`;
                            }else{
                                docs+=`<td>${ parseFloat(doc.total) }</td>
                                    </tr>`;
                            }
                                
                    }
                    
                });
                complete += `${init}${docs}`;
            });
            let totals=`<tr><td colspan="${this.totales_doc.snh > 0 ? 6:6 }"><b>TOTAL</b></td>`;
            if(this.totales_doc.snh > 0){
                totals+=`<td>${ (this.totales_doc.total - this.totales_doc.snh).toFixed(2) }</td>
                                <td>${this.totales_doc.snh.toFixed(2) }</td>
                                <td>${ this.totales_doc.total.toFixed(2)  }</td>
                            </tr>`;
            }else{
                totals+=`<td>${ this.totales_doc.total.toFixed(2)  }</td>
                            </tr>`;
            }
            complete+=totals;       

            this.table_master=complete;
        },
        mValidateForm(){
            if(this.operation_doc_select.id === null || this.operation_doc_select.id === 0){
                toastr.error('Seleccione el tipo de Operacion a buscar', 'Error');
                return false;
            }

            if(this.captain_doc_select === null || this.captain_doc_select === 0){
                toastr.error('Seleccione una Capitania', 'Error');
                return false;
            }

            let adi=this.doc_individually.init.split('T');
            this.doc_individually.init=adi[0];

            if( this.doc_individually.init === null || !(this.doc_individually.init.length === 10) ){
                toastr.error('La fecha de Inicio es incorrecta', 'Error');
                return false;
            }

            let adf=this.doc_individually.end.split('T');
            this.doc_individually.end=adf[0];

            if( this.doc_individually.end === null || !(this.doc_individually.end.length === 10) ){
                toastr.error('La fecha final es incorrecta', 'Error');
                return false;
            }
            return true;
        }
    }

}
</script>

<style>

.text-table{
    font-size: 13px;
    font-style: italic;
}

</style>


// WEBPACK FOOTER //
// src/components/finanzas/ReportEnter.vue